<h2 mat-dialog-title class="dialog-title">
  <span>{{ data.title }}</span>
  <button mat-icon-button mat-dialog-close [attr.aria-label]="'AI_ASSISTANT.TESTING.TOOL_CALL_MODAL.CLOSE' | translate">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <div>
    <div class="header-with-button">
      <h3>{{ 'AI_ASSISTANT.TESTING.TOOL_CALL_MODAL.ARGUMENTS' | translate }}</h3>
      <button mat-button color="primary" (click)="copyArguments()">
        <mat-icon class="copy-icon">content_copy</mat-icon>
        {{ 'AI_ASSISTANT.TESTING.TOOL_CALL_MODAL.COPY' | translate }}
      </button>
    </div>
    <pre><code>{{ parsedArguments | json }}</code></pre>
  </div>

  <div>
    <div class="header-with-button">
      <h3>{{ 'AI_ASSISTANT.TESTING.TOOL_CALL_MODAL.RESPONSE' | translate }}</h3>
      <button mat-button color="primary" (click)="copyResponse()">
        <mat-icon class="copy-icon">content_copy</mat-icon>
        {{ 'AI_ASSISTANT.TESTING.TOOL_CALL_MODAL.COPY' | translate }}
      </button>
    </div>
    <pre>{{ parsedResponse | json }}</pre>
  </div>
</mat-dialog-content>
